// Plugin para registrar trazas
//
// - permite deshabilitar las trazas globalmente
// - incluye una funcion para registrar la serializacion de un objeto/array (como JSON)

class Log {

  isArray (a) {
    return (!!a) && (a.constructor === Array);
  }

  isObject (a) {
    return (!!a) && (a.constructor === Object);
  }

  // log como Warning, pero si estamos en producción, no enviamos nada a la consola
  log () {
    if (process.env.NODE_ENV !== 'production')
      console.log.apply (this, arguments);
  }

  // log serializando objetos y arrays
  logs () {
    for (let i = 0; i < arguments.length; i++)
      if (this.isObject (arguments [i]) || this.isArray (arguments [i]))
         arguments [i] = JSON.stringify (arguments [i], undefined, 2);
    this.log.apply (this, arguments);
  }

  // log incluyendo fecha/hora y serializando objetos y arrays
  logts () {
    let ahora = new Date();
    this.logs.apply (this, [ahora.toISOString() + ' >', ...arguments]);
  }

}

export default {
  install (Vue, opciones) {
    const objetoLog = new Log (opciones);
    Vue.prototype.$log = objetoLog;
    Vue.prototype.log = function () { objetoLog.log.apply (objetoLog, arguments) };
    Vue.prototype.logs = function () { objetoLog.logs.apply (objetoLog, arguments) };
    Vue.prototype.logts = function () { objetoLog.logts.apply (objetoLog, arguments) };
  }
}